<template>
  <artmisads-modal v-model:open="visible" title="Accept Campaign" okText="save" :confirmLoading="saveLoading"
    :maskClosable="false" width="900px" :footer="null">
    <div class="content">
      <div class="content-top">
        Heading to the Amazon Associate Center, <span class="bold-text">please click the Accept button</span> on the
        Amazon Campaign details page.
      </div>
      <div class="content-mid">
        <div class="content-mid-text">
          <span class="content-mid-text-bold">Note:</span> After accepting the brand's ACC Campaign in Amazon Associate,
          it may take 1–2 days for the status to refresh in ArtemisAds.
        </div>
        <div class="content-mid-text">
          <span class="content-mid-text-bold">Important:</span> When accepting both the brand's ACC Campaign and the
          Associate Partnership, commissions for overlapping parts will be calculated according to the adjustment rules：
        </div>
      </div>
      <div class="popover-content">
        <div class="popover-content-title">
          Commission rate adjustment policy
        </div>
        <div class="popover-content-content">
          <img class="imgA" :src="require('@/assets/images/img/ass.png')" alt="Commission rate adjustment policy" />
          <img class="equal" :src="require('@/assets/images/img/equal.png')" alt="Commission rate adjustment policy" />
          <img class="imgA" :src="require('@/assets/images/img/accI.png')" alt="Commission rate adjustment policy" />
        </div>
        <div class="popover-content-text">
          Associate commissions to publishers is not required. （commission = $0）
        </div>
        <div class="popover-content-content">
          <img class="imgA" :src="require('@/assets/images/img/ass.png')" alt="Commission rate adjustment policy" />
          <img class="equal" :src="require('@/assets/images/img/greater.png')"
            alt="Commission rate adjustment policy" />
          <img class="imgA" :src="require('@/assets/images/img/accI.png')" alt="Commission rate adjustment policy" />
        </div>
        <div class="popover-content-text" style="margin-bottom: 0;">
          Only the difference is paid via ArtemisAds.
        </div>
      </div>
    </div>
     <!-- <template #footer>
       <div class="footer">
        <artmisads-button type="primary" @click="goPage">Jump To Amazon Associate Central</artmisads-button>
      </div>
     </template> -->
     <!-- <div class="divider"></div> -->
  </artmisads-modal>
</template>
<script setup>
import { ref, defineExpose } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const visible = ref(false)
const saveLoading = ref(false)
const open = (record) => {
  visible.value = true
}
const goPage=()=>{

}
defineExpose({
  open
})
</script>
<style lang="less" scoped>
.content {}

.content-top {
  border-radius: 8px;
  background-color: rgba(248, 247, 252, 1);
  padding: 16px;
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.9);
  margin-bottom: 20px;
}

.bold-text {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: rgba(138, 100, 244, 1);

}

.popover-content {
  border-radius: 8px;
  background-color: rgba(248, 247, 252, 1);
  padding: 12px 16px;
  margin: 20px 0 23px;


  .popover-content-title {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;
    padding-bottom: 24px;

  }

  .popover-content-text {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;
    margin-top: 10px;
    margin-bottom: 24px;
  }

  .equal {
    // width: 5px;
    height: 10px;
    margin: 0 10px;
  }

  .imgA {
    height: 16px;
  }
}

.divider {
  height: 1px;
  background-color: rgba(232, 229, 237, 1);
}
:deep(.artmisads-modal .ant-modal-footer){
  display: flex;
  align-items: center;
  justify-content: center !important;
}
.footer{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>